import * as pxp from '../lib/pxp'

export function hasContactConfidenceTreatment() {
  return pxp.isTreatment('Trmt_contact_confidence_interstitial')
}
